import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../../utils/fields/getFieldProps';
import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { FormErrorBlock } from '../../../common/FormErrorBlock';
import PasswordInput from '../../../TextInput/PasswordInput';
import DateDropdown from '../../../common/DateDropdown';
import ErrorBlock from '../../../common/ErrorBlock';
import { SSNField } from '../../../SSNField';
import TextInput from '../../../TextInput';

const {
  LAST_NAME,
  FIRST_NAME,
  DOB,
  SSN,
  LOGIN,
  EMAIL,
  PHONE_NUMBER,
} = PROFILE_FIELDS_TYPES;

export const PatientInfoForm = ({
  firstName,
  lastName,
  validateErrors,
  dob,
  ssn,
  login,
  formatMessage,
  onChange,
  serverError,
}) => {
  const makeProfileField = getFieldProps(formatMessage, onChange);
  const errors = serverError && <FormattedMessage {...serverError} />;

  return (
    <Fragment>
      {/*     F I R S T   N A M E     */}
      <TextInput {...makeProfileField(FIRST_NAME)} value={firstName} />
      <FormErrorBlock type={FIRST_NAME} errors={validateErrors} />
      {/*     L A S T   N A M E     */}
      <TextInput {...makeProfileField(LAST_NAME)} value={lastName} />
      <FormErrorBlock type={LAST_NAME} errors={validateErrors} />
      {/*     S S N     */}
      <SSNField
        formatMessage={formatMessage}
        children={<PasswordInput {...makeProfileField(SSN)} value={ssn} />}
      />
      <FormErrorBlock type={SSN} errors={validateErrors} />
      {/*     D O B     */}
      <DateDropdown {...makeProfileField(DOB)} value={dob} />
      {/*     L O G I N     */}
      <TextInput
        {...makeProfileField(LOGIN, FIELD_FILLING_TYPES.REQUIRED)}
        value={login}
        label={formatMessage({ id: 'profile.fields.emailOrPhone' })}
      />
      <FormErrorBlock type={EMAIL || PHONE_NUMBER} errors={validateErrors} />
      {serverError && <ErrorBlock errors={errors} className="mt3" />}
    </Fragment>
  );
};

PatientInfoForm.propTypes = {
  validateErrors: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ description: PropTypes.string }),
  ]),
  ssn: PropTypes.string,
  formatMessage: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  onChange: PropTypes.func,
  dob: PropTypes.string,
  login: PropTypes.string,
  serverError: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/DashboardRecord/DashboardPatientInfo/PatientInfoForm/index.jsx